const features = [
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '收录 2000+ 热门综艺节目，涵盖户外真人秀、音乐竞演、脱口秀、推理探案、恋爱观察等全品类内容，每日实时同步更新。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站支持 1080P 蓝光级画质播放，自适应码率技术根据网络状况智能调节，确保最佳观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '智能 CDN 全球加速节点覆盖，视频秒开不缓冲，拖拽进度条即时响应，告别等待焦虑。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费',
    desc: '无需注册会员、无需付费订阅，全站综艺节目免费观看全集，无广告打扰，纯粹观影享受。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '支持手机、平板、电脑多终端无缝切换，观影记录云端同步，随时随地继续追综。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              平台优势
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              为什么选择 51影视
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              五大核心优势，让追综体验更上一层楼
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {features.map((feat) => (
              <div
                key={feat.title}
                className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200 hover:border-primary-200 transition-all group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-all">
                  <i className={`${feat.icon} text-xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3 whitespace-nowrap">
                  {feat.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}